import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('criticalStatusBadge');

    return {
        CRITICAL: t('critical')
    };
};

export default useTranslation;
